export default __webpack_public_path__ + "static/media/leadinsights.114ee084.png";